import React, { useState } from "react";
import "../../../styles/Header-css/ServicePartner/PartnerProfile/MyBookings.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarAlt,
  faClock,
  faMapMarkerAlt,
  faCheck,
  faTimes,
  faEye,
  faSearch,
  faChevronDown,
} from "@fortawesome/free-solid-svg-icons";

// --- Helper functions for date comparisons ---

const parseBookingDate = (dateString) => new Date(dateString);

const isToday = (someDate) => {
  const today = new Date();
  return (
    someDate.getDate() === today.getDate() &&
    someDate.getMonth() === today.getMonth() &&
    someDate.getFullYear() === today.getFullYear()
  );
};

const isThisWeek = (someDate) => {
  const today = new Date();
  const firstDayOfWeek = new Date(today.setDate(today.getDate() - today.getDay()));
  const lastDayOfWeek = new Date(firstDayOfWeek);
  lastDayOfWeek.setDate(lastDayOfWeek.getDate() + 6);

  someDate.setHours(0, 0, 0, 0);
  firstDayOfWeek.setHours(0, 0, 0, 0);
  lastDayOfWeek.setHours(0, 0, 0, 0);

  return someDate >= firstDayOfWeek && someDate <= lastDayOfWeek;
};


const MyBookings = () => {
  const [currentFilter, setCurrentFilter] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const [dateFilter, setDateFilter] = useState("all");

  // NOTE: This data is set up to work with the current date (Sep 23, 2025)
  // for the "Today" and "This Week" filters.
  const bookings = [
    { id: 1, name: "Vikram Rathi", service: "Sofa Cleaning", date: "23 Sep 2025", time: "3:00 PM", distance: "6.3 km", amount: 1400, status: "pending" },
    { id: 2, name: "Priya Sharma", service: "House Deep Cleaning", date: "25 Sep 2025", time: "10:00 AM", distance: "2.5 km", amount: 1200, status: "pending" },
    { id: 3, name: "Amit Kumar", service: "Carpet Cleaning", date: "28 Sep 2025", time: "12:00 PM", distance: "3.1 km", amount: 800, status: "accepted" },
    { id: 4, name: "Neha Verma", service: "Kitchen Cleaning", date: "26 Oct 2025", time: "4:30 PM", distance: "4.5 km", amount: 1000, status: "active" },
    { id: 5, name: "Ravi Singh", service: "Bathroom Cleaning", date: "20 Oct 2025", time: "9:00 AM", distance: "1.8 km", amount: 600, status: "completed" },
    { id: 6, name: "Suresh Gupta", service: "Office Cleaning", date: "19 Nov 2025", time: "11:00 AM", distance: "8.2 km", amount: 2500, status: "completed" }
  ];

  const handleAccept = (id) => alert(`Booking #${id} Accepted`);
  const handleReject = (id) => alert(`Booking #${id} Rejected`);
  const handleView = (id) => alert(`Viewing details for booking #${id}`);

  const filteredBookings = bookings
    .filter((b) => currentFilter === "all" || b.status === currentFilter)
    .filter((b) => {
      if (dateFilter === "all") return true;
      const bookingDate = parseBookingDate(b.date);
      if (dateFilter === "today") return isToday(bookingDate);
      if (dateFilter === "this_week") return isThisWeek(bookingDate);
      return true;
    })
    .filter((b) => {
      if (searchTerm === "") return true;
      const lowerCaseSearch = searchTerm.toLowerCase();
      return (
        b.name.toLowerCase().includes(lowerCaseSearch) ||
        b.service.toLowerCase().includes(lowerCaseSearch)
      );
    });

  return (
    <div className="my-bookings">
      <div className="bookings-header">
        <h2>My Bookings</h2>
        <span className="bookings-count">{bookings.length} bookings</span>
      </div>

      <div className="filters-container">
        <div className="search-bar-wrapper">
          <FontAwesomeIcon icon={faSearch} className="search-icon" />
          <input
            type="text"
            placeholder="Search bookings..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="dropdowns-wrapper">
          <div className="select-wrapper">
            <select
              value={currentFilter}
              onChange={(e) => setCurrentFilter(e.target.value)}
            >
              <option value="all">All Status</option>
              <option value="pending">Pending</option>
              <option value="accepted">Accepted</option>
              <option value="completed">Completed</option>
            </select>
            <FontAwesomeIcon icon={faChevronDown} className="dropdown-arrow" />
          </div>
          <div className="select-wrapper">
              <select
              value={dateFilter}
              onChange={(e) => setDateFilter(e.target.value)}
            >
              <option value="all">All Dates</option>
              <option value="today">Today</option>
              <option value="this_week">This Week</option>
            </select>
            <FontAwesomeIcon icon={faChevronDown} className="dropdown-arrow" />
          </div>
        </div>
      </div>

      <div className="tabs">
        {["all", "pending", "accepted", "active", "completed"].map((tab) => (
          <button
            key={tab}
            className={`tab-btn ${currentFilter === tab ? "active" : ""}`}
            onClick={() => setCurrentFilter(tab)}
          >
            {tab.charAt(0).toUpperCase() + tab.slice(1)}
          </button>
        ))}
      </div>

      {filteredBookings.length > 0 ? (
        filteredBookings.map((b) => (
          <div key={b.id} className="booking-card">
            <div className="card-header">
              <div className="customer">
                <div className="avatar">{b.name.charAt(0)}</div>
                <div>
                  <div><strong>{b.name}</strong></div>
                  <div className="customer-service">{b.service}</div>
                </div>
              </div>
              <span className={`status ${b.status}`}>{b.status}</span>
            </div>
            <div className="details">
              <p>
                <FontAwesomeIcon icon={faCalendarAlt} /> {b.date} &nbsp;&nbsp;
                <FontAwesomeIcon icon={faClock} /> {b.time}
              </p>
              <p>
                <FontAwesomeIcon icon={faMapMarkerAlt} /> {b.distance}
              </p>
            </div>
            <div className="footer">
              <div className="price">₹{b.amount}</div>
              <div className="actions">
                {b.status === "pending" ? (
                  <>
                    <button className="btn reject" onClick={() => handleReject(b.id)}>
                      <FontAwesomeIcon icon={faTimes} /> Reject
                    </button>
                    <button className="btn accept" onClick={() => handleAccept(b.id)}>
                      <FontAwesomeIcon icon={faCheck} /> Accept
                    </button>
                  </>
                ) : (
                  <button className="btn details" onClick={() => handleView(b.id)}>
                    <FontAwesomeIcon icon={faEye} /> View Details
                  </button>
                )}
              </div>
            </div>
          </div>
        ))
      ) : (
        <p className="no-bookings">No bookings found.</p>
      )}
    </div>
  );
};

export default MyBookings;